import React from 'react';
import { Checkbox, Typography, Card, CardContent } from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';

class BenefitSelection extends React.Component {
  state = {
    benefits: [
      {
        id: 3,
        name: 'Life Cover',
        minAge: 20,
        maxAge: 80,
        disabled: false,
        messages: [],
        compValidation: {}
      },
      {
        minAge: 20,
        maxAge: 70,
        id: 5,
        name: 'Critical Illness',
        disabled: false,
        messages: []
      },
      {
        minAge: 20,
        maxAge: 60,
        id: 55,
        name: 'Disability Lumpsum',
        disabled: false,
        messages: []
      },
      {
        minAge: 20,
        maxAge: 60,
        id: 56,
        name: 'Temporary Income Protector',
        disabled: this.props.doesNotQualifyForIP,
        messages: [
          this.props.doesNotQualifyForIP
            ? "Client's occupation does not qualify for this benefit"
            : ''
        ]
      },
      {
        minAge: 20,
        maxAge: 60,
        id: 57,
        name: 'Extended Income Protector',
        disabled: this.props.doesNotQualifyForIP,
        messages: [
          this.props.doesNotQualifyForIP
            ? "Client's occupation does not qualify for this benefit"
            : ''
        ]
      }/*,
			{
				minAge: 20,
				maxAge: 60,
				id: 58,
				name: 'Death Income Protector (Beta)',
				disabled: this.props.doesNotQualifyForIP,
				messages: [
					this.props.doesNotQualifyForIP
						? "Client's occupation does not qualify for this benefit"
						: ''
				]
			}*/
    ]
  };

  componentDidMount() {
    this.props.scrollMeBar();

    let { benefits } = this.state;
    benefits.map(benefit => {
      if (this.props.clientAge) {
        if (this.props.clientAge > benefit.maxAge) {
          benefit.disabled = true;
          benefit.messages.push(
            'Client is too old to qualify for this benefit'
          );
        }
        if (this.props.clientAge < benefit.minAge) {
          benefit.disabled = true;
          benefit.messages.push(
            'Client is too young to qualify for this benefit'
          );
        }
      }
      return benefit;
    });

    if (!this.props.benefitsInitialized && this.props.autoPopulatedBenefits) {
      let editBenefits = this.props.autoPopulatedBenefits
        .split(',')
        .map(t => parseInt(t, 10));
      let autoPopBenefits = [];

      benefits.map(ben => {
        if (editBenefits.includes(ben.id)) {
          autoPopBenefits.push(ben.id);
        }
        return ben;
      });

      this.props.setBenefitsInitialized(autoPopBenefits);
    }

    this.setState({ benefits: benefits });
  }

  handleCheck = id => {
    if (this.props.selectedBenefits.find(t => t === id)) {
      this.props.checkSelectedBenefit(id, false);
    } else {
      this.props.checkSelectedBenefit(id, true);
    }
    this.forceUpdate();
  };

  enabledBenefits() {
    const { benefits } = this.state;
    return benefits.filter(benefit => !benefit.disabled);
  }

  checkAll = () => {
    if (this.props.selectedBenefits.length !== this.enabledBenefits().length) {
      this.props.toggleAllBenefits(this.enabledBenefits(), true);
    } else {
      this.props.toggleAllBenefits(this.enabledBenefits(), false);
    }
    this.forceUpdate();
  };

  render() {
    const allSelected =
      this.props.selectedBenefits.length === this.enabledBenefits().length;

    return (
      <div className='contentWithStepper'>
        <Card className={this.classes}>
          <CardContent>
            <CustomCardHeading
              subheading='Quote Generation'
              caption={this.props.clientFullname}
              headline='Benefit Selection'
            />

            <div style={{ display: 'block', width: '100%', marginTop: '15px' }}>
              <div style={{ display: 'flex' }}>
                <Checkbox checked={allSelected} onChange={this.checkAll} />
                <p
                  className={'checkBoxText'}
                  style={{ fontSize: '15px', color: '#6f6d6d' }}
                >
                  Select All
                </p>
              </div>
              <div style={{ width: '100%' }}>
                {this.state.benefits.map(benefit => {
                  var isSelected = false;
                  if (this.props.selectedBenefits.find(t => t === benefit.id)) {
                    isSelected = true;
                  }

                  return (
                    <div
                      key={benefit.id}
                      className={`checkboxContainer${
                        benefit.disabled ? ' disabledRow' : ''
                      }`}
                      style={
                        isSelected
                          ? { backgroundColor: '#f5f5f5' }
                          : {
                              cursor: benefit.disabled
                                ? 'not-allowed'
                                : 'pointer'
                            }
                      }
                      onClick={() =>
                        benefit.disabled ? {} : this.handleCheck(benefit.id)
                      }
                    >
                      <Checkbox checked={isSelected} />
                      <p className={'checkBoxText'}>{benefit.name}</p>
                      {benefit.disabled && benefit.messages.length > 0 ? (
                        <div
                          className={'checkBoxText'}
                          style={{ display: 'block', paddingTop: '5px' }}
                        >
                          {benefit.messages.map((message, i) => {
                            return (
                              <Typography
                                key={i}
                                variant='caption'
                                style={{ color: 'red' }}
                              >
                                {message}
                              </Typography>
                            );
                          })}
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default BenefitSelection;



// WEBPACK FOOTER //
// ./src/views/Quote/QuoteWizard/steps/BenefitSelection.jsx